<div class="row">
    <div class="col-xl-8">
        <div class="card card-box bg-primary border-primary p-4 text-white mb-5">
            <span class="ribbon-angle ribbon-angle--top-right ribbon-success"><small>Best</small></span>
            <h5 class="display-5 font-weight-bold mb-4">
                Active subscription
            </h5>
            <div class="no-gutters row">
                <div class="col-md-6 d-flex align-items-center flex-column">
                    <div class="divider-v bg-white opacity-3 divider-v-md"></div>
                    <div>
                        <div class="mb-3">
                            <span class="display-2 font-weight-bold">$29</span>
                            <span class="opacity-8">/ month</span>
                        </div>
                        <ul class="p-0 opacity-7 m-0">
                            <li>
                                Commercial license included
                            </li>
                            <li>
                                Multiple developers allowed
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                    <div class="text-center">
                        <div class="mb-3 font-size-lg font-weight-bold">
                            License active for next <b>65</b> days
                        </div>

                        <button class="btn btn-danger px-3 py-1 font-size-xs font-weight-bold text-uppercase">
                            <small>
                                Renew now
                            </small>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box bg-warning border-warning card-shadow-warning text-center p-4 text-white mb-5">
            <span class="ribbon-vertical ribbon-vertical--second ribbon-vertical--right text-uppercase"><span>-30%</span></span>
            <h5 class="display-5 font-weight-bold mb-4">
                Active subscription
            </h5>
            <div class="divider bg-white mb-4 opacity-3"></div>
            <div>
                <div class="mb-2">
                    <span class="display-2 font-weight-bold">$29</span>
                    <span class="opacity-8">/ month</span>
                </div>
                <ul class="list-unstyled opacity-6 mb-4">
                    <li>
                        Commercial license included
                    </li>
                </ul>
            </div>
            <div class="divider bg-white mb-4 opacity-3"></div>
            <div class="mb-3 font-size-lg font-weight-bold">
                License active for next <b>65</b> days
            </div>
            <button class="btn btn-second d-inline-block btn-pill">
                Renew now
            </button>
        </div>
    </div>
</div>
